import { render, staticRenderFns } from "./ReportPerformanceBands.vue?vue&type=template&id=392cb224&scoped=true"
import script from "./ReportPerformanceBands.vue?vue&type=script&lang=js"
export * from "./ReportPerformanceBands.vue?vue&type=script&lang=js"
import style0 from "./ReportPerformanceBands.vue?vue&type=style&index=0&id=392cb224&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392cb224",
  null
  
)

export default component.exports